import type { ProductCopyDto } from "../../types/ProductCopyDto";
import type { ProductCopyEntity } from "../../types/ProductCopyEntity";
import { ProductType } from "../../types/ProductTypeEnum";

export const ProductCopyEntityToCopyDto = ({ ...rest }: Readonly<ProductCopyEntity>): ProductCopyDto => {
    const itemType = rest.productCode ? ProductType.product : ProductType.productCategory;

    return { ...rest, itemType };
};
